<template>
  <a-card :bordered="false">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="专题名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.subjectCustTitle" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item v-bind="searchItemLayout" style="margin-left: 15px;">
            <a-button type="primary" @click="$refs.pageList.refresh(true)">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-paging-dragging-list
      ref="pageList"
      rowKey="subjectmerchantId"
      :queryParams="queryParams"
      :columns="getColumns()"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <span slot="action" slot-scope="rowItem">
          <!-- <a @click="handleClick(rowItem.record.subjectmerchantId)">投放</a>-->
          <a v-if="rowItem.record.subjectStatus==0" @click="handleUpOrdown(rowItem.record.subjectmerchantId,1)">上架</a>
          <a v-if="rowItem.record.subjectStatus==1" @click="handleUpOrdown(rowItem.record.subjectmerchantId,0)">下架</a>
          <a-divider type="vertical"></a-divider>
          <a @click="editProject(rowItem.record.subjectmerchantId,rowItem.record.subjectId)">修改</a>
          <a-divider type="vertical"></a-divider>
          <a @click="lookH5SpecialUrl(rowItem.record.subjectmerchantId)">查看链接</a>
        </span>
    </custom-paging-dragging-list>
    <a-modal title="投放设置" v-model="visible" @ok="handleOk" width="700px">
      <a-table :dataSource="listData" :columns="getTableColumns()" :pagination="false" columnWidth="700px">
        <span slot="channel" slot-scope="text, record">
          {{ record.type == 1 ? '首页' : record.type == 2 ? '搜索页' : record.type == 3 ? '酒店频道页' : record.type == 4 ? '酒店频道页' : record.type == 5 ? '门票频道页' : record.type == 6 ? '门票频道页' : record.type == 7 ? '首页' : '' }}
        </span>
        <span slot="position" slot-scope="text, record">
          {{ record.type == 1 ? '首页轮播图' : record.type == 2 ? '搜索发现' : record.type == 3 ? '频道轮播图' : record.type == 4 ? '频道主题icon' : record.type == 5 ? '频道轮播图' : record.type == 6 ? '频道主题icon' : record.type == 7 ? '首页主题icon' : '' }}
        </span>
        <span slot="goodsSet" slot-scope="text, record">
          <a-input :maxLength="6" v-model="record.content" style="width: 200px" v-if="record.type == 2"
                   placeholder="6字以内"/>
          <a-upload
            v-else
            name="file"
            :before-upload="handleBeforeUploadImage"
            :multiple="false"
            :action="uploadFileUrl"
            @change="fileInfo=>handleChange(fileInfo,record.key)"
            :showUploadList="false"
          >
            <a-button @click="changeimg(record)"> 点击上传 </a-button>
            <span v-if="record.type == 3||record.type == 5">素材尺寸:750px*220px</span>
            <span v-else>素材尺寸:120px*120px</span>
          </a-upload>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" v-if="record.status == 2" @click="openchange(record.key)">开启</a-button>
          <a-button v-else type="link" @click="colosechange(record.key)">关闭</a-button>
        </span>
      </a-table>
    </a-modal>
    <a-modal title="复制链接" :width="500" v-model="visibleLink" @cancel="visibleLink=false" :destroyOnClose='true'
             :footer="null">
      <a-textarea v-model="urlLink" :autoSize="{ minRows: 3, maxRows: 5 }"/>
      <a-button v-clipboard:copy="urlLink" v-clipboard:success="onCopy"
                v-clipboard:error="onError" style="margin-top:20px" type="primary">复制
      </a-button>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'
import SpecialMixins from './SpecialMixins'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'ServiceStyleComponent',
  components: {
    CustomPagingDraggingList
  },
  mixins: [searchForm, formMixin, SpecialMixins],
  data() {
    return {
      queryParams: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      loadPromise: params => this.getListPromise(params),
      visible: false,
      listData: [], // '投放设置数据'
      uploadFileUrl: this.getAppConfig().baseUrl + '/base/upload',//文件上传地址
      imgIndex: '', // '获取 点击上传图片按钮的键值'
      fileList: [],
      visibleLink: false,
      urlLink: ''
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG',
      [{ name: 'StyleService', title: '我的专题' },
        { name: 'ServiceThemeTemplate', title: '专题模板' }
      ])
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
  },
  mounted() {

  },
  methods: {
    // 拖拽排序功能
    onDraggable(rowItem) {
      this.getLogUtils().logWithTag('==onDraggable排序==', rowItem)
      let idList = rowItem.dataList.map(item => item.subjectmerchantId)
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        listOrder: {
          idList: idList,
          pageNum: rowItem.pageNo,
          pageSize: rowItem.pageSize
        }
      }
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      this.getHttpServices().getServerApiService().post('updateSubjectSort', params).then(res => {
        this.$message.success('排序成功')
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCopy(e) {
      this.$message.success('复制成功')
      this.visibleLink = false
    },
    onError(e) {
      this.$message.error('复制失败')
      this.visibleLink = false
    },
    // '编辑专题'
    editProject(subjectMerchantId, subjectId) {
      this.$router.push({
        name: 'AddThemeTemplate',
        query: {
          subjectMerchantId: subjectMerchantId,
          subjectId: subjectId,
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId,
          domainUrl: this.$store.getters.h5DomainUrl
        }
      })
    },
    //预览H5商城路径url
    lookH5SpecialUrl(subjectMerchantId) {
      if (subjectMerchantId) {
        this.visibleLink = true
        let params = {
          p: `${1}_${this.merchantId}_${this.merchantId}`,
          subjectMerchantId: subjectMerchantId
        }
        this.urlLink = RouterSwitchHelper.getProductSpecialPathUrl(this.$store.getters.h5DomainUrl, params)
      } else {
        this.$message.error('预览错误，请联系管理员')
      }
    },
    handleUpOrdown(subjectMerchantId, status) {
      let textStr = status == 1 ? '上架' : '下架'
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        status: status,
        subjectmerchantId: subjectMerchantId
      }
      this.getHttpServices().getServerApiService().post('editSubjectMerchantStatus', params)
        .then(res => {
          this.$message.success(textStr + '成功')
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('getSubjectMerchantList', params)
    },
    //功能取消
    handleClick(subjectMerchantId) {// '投放设置
      this.visible = true
      this.listData = []
      this.getTypeEnum(subjectMerchantId)
    },
    getTypeEnum(subjectMerchantId) { //投放展示位集合数据
      this.getHttpServices().getServerApiService().post('specialSubject/delivery/getTypeEnum')
        .then(res => {
          res.forEach((item, index) => {
            let obj = new Object()
            obj.key = index
            obj.content = ''
            obj.id = ''
            obj.merchantId = this.queryParams.merchantId
            obj.platformId = this.queryParams.platformId
            obj.specialSubjectId = subjectMerchantId
            obj.status = 2
            obj.type = item.value
            obj.updateTime = ''
            this.listData.push(obj)
          })
          this.getList(subjectMerchantId)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getList(subjectMerchantId) { //投放设置列表
      let params = {
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId,
        specialSubjectId: subjectMerchantId
      }
      this.getHttpServices().getServerApiService().post('specialSubject/delivery/getList', params)
        .then(res => {
          res.forEach((item, index) => {
            this.listData.forEach((items, indexs) => {
              if (items.type == item.type) {
                items.content = item.content
                items.id = item.id
                items.merchantId = item.merchantId
                items.platformId = item.platformId
                items.specialSubjectId = item.specialSubjectId
                items.status = item.status
                items.type = item.type
                items.updateTime = item.updateTime
              }
            })
          })
          this.getLogUtils().logWithTag('投放设置列表', this.listData)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(file, index) { //  图片上传成功
      if (file.file.status != 'removed') {
        let url = this.getLatestUrlFromFileList(file.fileList)
        if (url) {
          this.$message.success('图片上传成功')
          this.listData.forEach((item, index) => {
            if (this.imgIndex == index) {
              item.content = url
            }
          })
        }
      }
      this.getLogUtils().logWithTag('投放设置列表', this.listData)
    },
    changeimg(record) {
      this.imgIndex = record.key
    },
    colosechange(id) {// '关闭操作'
      this.listData.forEach((item, index) => {
        if (id == index) {
          item.status = 2
        }
      })
    },
    openchange(id) {// '开启操作'
      this.listData.forEach((item, index) => {
        if (id == index) {
          item.status = 1
        }
      })
    },
    handleOk() { //确定保存设置
      var arr = new Array()
      this.listData.forEach((item, index) => {
        if (item.content) {
          var obj = new Object()
          obj.content = item.content
          obj.id = item.id
          obj.merchantId = item.merchantId
          obj.platformId = item.platformId
          obj.specialSubjectId = item.specialSubjectId
          obj.status = item.status
          obj.type = item.type
          obj.updateTime = item.updateTime
          arr.push(obj)
        }
      })
      this.getHttpServices().getServerApiService().post('specialSubject/delivery/save', arr)
        .then(res => {
          this.$message.success('设置成功')
          this.visible = false
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'subjectmerchantId',
          width: '80px'
        },
        {
          title: '专题名称',
          dataIndex: 'subjectCustTitle',
          width: '28%'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '80px'
        },
        {
          title: '使用模板',
          dataIndex: 'subjectThemesName'
        },
        {
          title: '状态',
          dataIndex: 'subjectStatusStr',
          width: '80px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getTableColumns() {
      return [
        {
          title: '投放渠道',
          dataIndex: 'channel',
          scopedSlots: { customRender: 'channel' }
        },
        {
          title: '展示位',
          dataIndex: 'position',
          scopedSlots: { customRender: 'position' }
        },
        {
          title: '物料设置',
          dataIndex: 'goodsSet',
          scopedSlots: { customRender: 'goodsSet' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
</style>